<template>
  <div class="CommandPag">
    <el-pagination
      background
      :small="elSize"
      class="pagination"
      :total="CommandTotal"
      :pager-count="5"
      :current-page.sync="CommandCurrentPage"
      :page-size="CommandpageSize"
      :page-sizes="[50, 100]"
      @current-change="handleChangePage"
      @size-change="handleSizePage"
      layout="total, sizes, prev, pager, next, jumper"
      :prev-text="$t('common.pagination.prev')"
      :next-text="$t('common.pagination.next')"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      CommandTotal: 1,
      CommandCurrentPage: 1,
      CommandpageSize: 50,
      elSize: false,
    };
  },
  props: ["isize"],
  created() {
    this.elSize = this.isize;
  },
  methods: {
    handleChangePage(val) {
      let param = {
        pageNum: val,
        pageSize: this.CommandpageSize,
      };
      this.$emit("PageFun", param);
    },
    handleSizePage(val) {
      this.CommandpageSize = val;
      let param = {
        pageNum: 1,
        pageSize: val,
      };
      this.$emit("PageFun", param);
    },
  },
};
</script>

<style lang="less" scoped>
.CommandPag {
  padding: 20px 0 0;
  text-align: right;
  
  /deep/.el-pagination {
    padding: 0;
    height: 24px;
    span:not([class*="suffix"]) {
      height: 24px;
      line-height: 24px;
    }
    .el-pagination__total {
      font-size: 14px;
      color: #fff;
      line-height: 24px;
      margin-right: 0;
    }
    .el-pagination__sizes {
      margin: 0;
      .el-input__inner {
        font-size: 14px;
        color: #fff;
        text-align: left;
        padding: 0 10px;
        height: 24px;
        width: 90px;
        background-color: transparent;
        border-radius: 0;
        border-color: #7f8791;
      }
    }
    .btn-prev,
    .btn-next {
      min-width: 24px;
      height: 24px;
      background-color: #7f8791;
      color: #fff;
      border-radius: 0;
    }
    .el-pager li {
      min-width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 0;
      background-color: transparent;
      border: 1px solid #7f8791;
      color: #fff;
    }
    .el-pager li:not(.disabled).active {
      border: none;
    }
    .el-pagination__jump {
      margin-left: 15px;
      font-size: 14px;
      color: #fff;
      .el-pagination__editor.el-input{
        height: 24px;
        line-height: 24px;
        border: none;
        .el-input__inner {
        width: 40px;
        height: 23px;
        line-height: 25px;
        background-color: transparent;
        border-radius: 0;
        border-color: #7f8791;
        color: #fff;
      }
      }
      
    }
  }
}
</style>
